import React from 'react';
import { BODY, MONO } from './register';

/* Numbered steps joined by a line: a vertical timeline on phones, a single
   row on desktop. Replaces a grid of step cards with one quiet structure. */

export default function Timeline({ steps }) {
  return (
    <ol className="grid lg:grid-cols-3 lg:gap-10">
      {steps.map((s, i) => (
        <li key={s.title} className="relative pb-9 pl-14 last:pb-0 lg:pb-0 lg:pl-0 lg:pt-16">
          <span
            className={`${MONO} absolute left-0 top-0 grid h-10 w-10 place-items-center rounded-full text-[0.75rem] ${i === 0 ? 'bg-[#171717] text-[#ffffff]' : 'border border-[#d6d6d6] bg-[#ffffff] text-[#171717]'}`}
            aria-hidden="true"
          >
            {i + 1}
          </span>
          {i < steps.length - 1 ? (
            <span
              aria-hidden="true"
              className="absolute bottom-0 left-5 top-12 w-px bg-gradient-to-b from-[#d6d6d6] to-[#ececec] lg:bottom-auto lg:left-14 lg:right-0 lg:top-5 lg:h-px lg:w-auto lg:bg-gradient-to-r"
            />
          ) : null}
          <h3 className="pt-1.5 text-[1.375rem] font-medium leading-tight tracking-[-0.02em] text-[#171717] lg:pt-0 lg:text-[1.75rem]">
            {s.title}
          </h3>
          <p className={`${BODY} mt-2 max-w-[34ch]`}>{s.desc}</p>
        </li>
      ))}
    </ol>
  );
}
